import {
  fetch
} from '@/plugin/axios/index.js'
import formAxios from '@/plugin/axios/formAxios.js'

/**
 * @param {Object} data
 * 列表列表
 */
export function getReceiveList(data) {
  return fetch({
    url: '/financial/receive/pageList',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 删除单据
 */
export function deleteReceive(data) {
  return fetch({
    url: '/financial/receive/delete',
    method: 'POST',
    data
  })
}

/**
 * @param {Object} data
 * 保存单据
 */
export function saveReceive(data) {
  return fetch({
    url: '/financial/receive/save',
    method: 'POST',
    data
  })
}

/**
 * @param {Object} data
 * 保存单据
 */
export function saveReceiveList(data) {
  return fetch({
    url: '/financial/receive/patchSaveFinancialReceive',
    method: 'POST',
    data: {
      "financialReceiveList": data
    }
  })
}
/**
 * @param {Object} data
 * 通过审核
 */
export function passReceive(data) {
  return fetch({
    url: '/financial/receive/pass',
    method: 'POST',
    data
  })
}

export function getReceiveTypeList() {
  return fetch({
    url: '/financial/receive/getReceiveTypeList',
    method: 'GET'
  })
}

export function userSimpleList(data) {
  return fetch({
    url: '/auth/user/simpleList',
    method: 'POST',
    data
  })
}

/**
 * @param {Object} data
 * 获取使用单位列表
 */
export function getPropertyUnitSimpleList(data) {
  return fetch({
    url: '/auth/subPlatform/propertyUnit/simpleList',
    method: 'POST',
    data
  })
}
/**
 * @param {Object} data
 * 获取使用单位列表
 */
export function getReminderPageList(data) {
  return fetch({
    url: '/financial/receive/reminderPageList',
    method: 'POST',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/Receive/index.js